require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var Handlebars = require('handlebars');

var TheView = Backbone.View.extend({
	Template: null,
	template: null,
	myDomId: null,
	domain: null,
	options: {},
	views: {},
	validations: {
	    "isEmpty": function(self, element){
	        return self.isEmpty(element);
	    },
	    "isPercentage": function(self, element){
            return self.isPercentage(element);
        },
        "checkRange": function(self, element){
            return self.checkRange(element);
        },
        "greaterThan": function(self, element){
            return self.greaterThan(element);
        },
        "greaterThanField": function(self, element){
            return self.greaterThanField(element);
        },
        "isNumber": function(self, element) {
            return self.isNumber(element);
        }
	},
	initialize: function () {
	},
	storeView: function(view, name) {
	    this.views[name] = view;
	},
	validateSingleField: function(field)
	{
	    var self = this;
        var has_error = false;

        var data_validation = field.data("validation");
        var validations = data_validation.trim().split(" ");
        $.each(validations, function(i, value) {
            if (has_error == true)
                return ;
            has_error = self.validations[value](self, field);
        });

        return has_error;
	},
    validateFields: function(fields) {
        var self = this;
        var has_error = false;

        $.each(fields, function() {
            var field = $(this);
            if (field.data("validation")) {
                var data_validation = field.data("validation");
                var validations = data_validation.trim().split(" ");

                $.each(validations, function(i, value) {
                    if (has_error == true)
                        return ;
                    has_error = self.validations[value](self, field);
                });
            }

        });

        return has_error;
    },
    setError: function(element, error_msg) {
        if((typeof element) == "string")
            element = $(element);

        var errorSpan = element.parent().find(".error-block");
        errorSpan.addClass("has-error");
        errorSpan.text(error_msg);
    },
    clearError: function(element) {
        if((typeof element) == "string")
            element = $(element);

        var errorSpan = element.parent().find(".error-block");
        errorSpan.removeClass("has-error");
        errorSpan.find("span.error-block").text("");
    },
    clearAllErrors: function(elements) {
        $.each(elements, function(index, el) {
            $(el).removeClass('has-error');
        });
    },
    isEmpty: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        if ( element.val() == "") {
            this.setError(errorSpan, "This field can't be empty.");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    isPercentage: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        if ( element.val() < 0 || element.val() > 100) {
            this.setError(errorSpan, "This field gets values between 0 and 100.");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    isNumber: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        if ( isNaN(element.val()) ) {
            this.setError(errorSpan, "Invalid data.");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    checkRange: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        var range = element.data("range").split(",");
        var min = parseInt(range[0]);
        var max = parseInt(range[1]);
        var value = parseFloat(element.val());

        if ( value < min || value > max) {
            this.setError(errorSpan, "This field gets values between " + min + " and " + max + ".");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    greaterThan: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        var greater = element.data("greater");
        var value = parseFloat(element.val());

        if ( value < greater) {
            this.setError(errorSpan, "This field gets values greater than " + greater + ".");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    greaterThanField: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        var id = element.data("field-id");
        var greater = $("#"+id).val();
        var value = parseFloat(element.val());

        if ( value < greater) {
            this.setError(errorSpan, "This field gets values greater than " + greater + ".");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    convertToFloat: function(element) {
        var value = $(element).val();
        return isNaN(value) ? value : parseFloat(value);
    },
    convertToInt: function(element) {
        var value = $(element).val();
        return isNaN(value) ? value : parseInt(value);
    },
    collapseDescription: function(btn) {
        var message = $(btn).parent().parent().find(".message-container");

        if ( $(message).css('display') == 'none' ) {
            $(btn).removeClass("fa-plus-square").addClass("fa-minus-square");
            $(message).removeClass("hide");
        } else {
            $(btn).removeClass("fa-minus-square").addClass("fa-plus-square");
            $(message).addClass("hide");
        }
    },
    createBarChart: function(chart, title, x, y, data1, data2, labels, dataset1name, dataset2name, color1, color2, displayLegend) {
        var ctx = document.getElementById(chart).getContext('2d');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: dataset1name,
                        backgroundColor: color1,
                        data: data1
                    },
                    {
                        label: dataset2name,
                        backgroundColor: color2,
                        data: data2
                    }
                ]
            },
            options: {
                responsive: true,
                aspectRatio: 3,
                maintainAspectRatio: false,
                legend: {
                    display: displayLegend,
                },
                title: {
                    display: true,
                    text: title,
                    fontSize: '16'
                },
                layout: {
                    padding: {
                        left: 10,
                        right:10,
                        top: 10,
                        bottom: 10
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: x
                        },
                        barPercentage: 0.5
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: y
                        },
                        ticks: {
                            beginAtZero: true
                        },
                    }]
                }
            }
        });

        myChart.canvas.parentNode.style.height = '350px';
        myChart.canvas.parentNode.style.width = '90%';
    },
    createTimeTable: function() {
        var x = 15; //minutes interval
        var times = []; // time array
        var tt = 0; // start time

        //loop to increment the time and push results in array
        for (var i=0; tt<24*60; i++) {
          var hh = Math.floor(tt/60); // getting hours of day in 0-24 format
          var mm = (tt%60); // getting minutes of the hour in 0-55 format
          times[i] = ("0" + (hh % 24)).slice(-2) + ':' + ("0" + mm).slice(-2); // pushing data in array in [00:00 - 24:00 format]
          tt = tt + x;
        }

        return times;
    }
});

module.exports = TheView;